import { sessionPrefix } from "./helpers";

export const acdCallsPath = (session: LightSessionInterface) => `${sessionPrefix(session)}/acd/calls`;
export const showAcdCallPath = (session: LightSessionInterface, call: TtAcdCallInterface) =>
  `${sessionPrefix(session)}/acd/calls/${call.id}`;
export const acdDashboardPath = (session: LightSessionInterface) => `${sessionPrefix(session)}/acd/dashboard`;
